import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AppShell from "@/pages/AppShell";
import Dashboard from "@/pages/Dashboard";
import Parties from "@/pages/Parties";
import Items from "@/pages/Items";
import PriceLists from "@/pages/PriceLists";
import Documents from "@/pages/Documents";
import DocumentForm from "@/pages/DocumentForm";
import DocumentView from "@/pages/DocumentView";
import Payments from "@/pages/Payments";
import Ledger from "@/pages/Ledger";
import Overdue from "@/pages/Overdue";
import Bills from "@/pages/Bills";
import Terms from "@/pages/Terms";
import Financials from "@/pages/Financials";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

// Load fonts
function Fonts() {
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href =
      "https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap";
    document.head.appendChild(l);
    return () => document.head.removeChild(l);
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <Fonts />
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <AppShell />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Parties kind="customer" />} />
              <Route path="suppliers" element={<Parties kind="supplier" />} />
              <Route path="items" element={<Items />} />
              <Route path="pricelists" element={<PriceLists />} />
              <Route path="invoices" element={<Documents kind="INV" />} />
              <Route path="purchase-orders" element={<Documents kind="PO" />} />
              <Route path="invoices/new" element={<DocumentForm kind="INV" />} />
              <Route path="purchase-orders/new" element={<DocumentForm kind="PO" />} />
              <Route path="documents/:doc_id" element={<DocumentView />} />
              <Route path="bills" element={<Bills />} />
              <Route path="terms" element={<Terms />} />
              <Route path="payments" element={<Payments />} />
              <Route path="ledger" element={<Ledger />} />
              <Route path="overdue" element={<Overdue />} />
              <Route path="financials" element={<Financials />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
